import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#207146" }}>Brief</span>
            </h2>
            <p>
              True Vine Media (TVM) is a unique networking application that
              helps people stay connected with their church and its fellowship.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#76CE51" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#76CE51" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#76CE51" }}> WEBSITE DEVELOPMENT</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
